import React, { useState, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { FaMicrophone, FaStop, FaRedo } from 'react-icons/fa';

const MicRecorderPreview = ({ onConfirm }) => {
	const [recording, setRecording] = useState(false);
	const [audioUrl, setAudioUrl] = useState(null);
	const mediaRecorderRef = useRef(null);
	const chunks = useRef([]);

	const startRecording = async () => {
		try {
			const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
			mediaRecorderRef.current = new MediaRecorder(stream);

			mediaRecorderRef.current.ondataavailable = (event) => {
				if (event.data.size > 0) {
					chunks.current.push(event.data);
				}
			};

			mediaRecorderRef.current.onstop = () => {
				const blob = new Blob(chunks.current, { type: 'audio/webm' });
				const url = URL.createObjectURL(blob);
				setAudioUrl(url);
				chunks.current = [];
				onConfirm();
			};

			chunks.current = [];
			mediaRecorderRef.current.start();
			setRecording(true);

			// auto-stop after 3 seconds
			setTimeout(() => {
				if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
					mediaRecorderRef.current.stop();
					setRecording(false);
				}
			}, 3000);
		} catch (error) {
			console.error("Error al iniciar grabación:", error);
		}
	};

	const stopRecording = () => {
		if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
			mediaRecorderRef.current.stop();
			setRecording(false);
		}
	};

	const resetRecording = () => {
		setAudioUrl(null);
		setRecording(false);
	};

	const renderControls = () => {
		if (!audioUrl) {
			return (
				<Button
					variant={recording ? 'danger' : 'primary'}
					onClick={recording ? stopRecording : startRecording}
				>
					{recording ? <FaStop /> : <FaMicrophone />} {recording ? 'Stop' : 'Record'}
				</Button>
			);
		}

		return (
			<Button variant="warning" onClick={resetRecording}>
				<FaRedo /> Re-record
			</Button>
		);
	};

	return (
		<div className="d-flex flex-column align-items-center">
			<div className="d-flex align-items-center gap-3 mb-2">
				{renderControls()}
			</div>

			{recording && (
				<div className="text-danger fw-bold">Recording...</div>
			)}

			{audioUrl && (
				<audio controls className="w-100">
					<source src={audioUrl} type="audio/webm" />
					Tu navegador no soporta reproducción de audio.
				</audio>
			)}
		</div>
	);
};

export default MicRecorderPreview;